/* eslint-disable @tanstack/query/exhaustive-deps -- queryFn closes over Clerk getToken; cache keyed by userId+sessionId */
import { useAuth } from '@clerk/react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fetchTerritory,
  generateTerritoryFsas,
  saveTerritory
} from '../api/accountApi';
import { useAccountGetToken } from './useAccountApi';

export function useTerritory() {
  const { userId, sessionId } = useAuth();
  const getToken = useAccountGetToken();
  return useQuery({
    queryKey: ['account', 'territory', userId, sessionId],
    queryFn: () => fetchTerritory(getToken),
    enabled: Boolean(userId)
  });
}

export function useSaveTerritory() {
  const getToken = useAccountGetToken();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: {
      centerLat: number;
      centerLng: number;
      radiusM: number;
      postalFsaPrefixes?: string[];
    }) => saveTerritory(getToken, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['account', 'territory'] });
    }
  });
}

export function useGenerateTerritoryFsas() {
  const getToken = useAccountGetToken();
  return useMutation({
    mutationFn: (body: {
      centerLat: number;
      centerLng: number;
      radiusM: number;
    }) => generateTerritoryFsas(getToken, body)
  });
}
